const serviceRegions = {
  getServiceRegions: (type) => `/service-regions/type/${type}`,
  getServiceRegionsDetailed: (type) => `/service-regions/type/${type}/detailed`,
  addServiceRegion: () => `/service-regions`,
  deleteServiceRegion: (id) => `/service-regions/${id}`,
  updateServiceRegion: (id) => `/service-regions/${id}`,
  searchServiceRegions: (type, searchTerm) => `/service-regions/type/${type}/search?searchTerm=${searchTerm}`,
};

export default serviceRegions;
